// extracted by mini-css-extract-plugin
export default {"container":"carousel_container__wde3C","loader":"carousel_loader__zBh6z"};